import React, { useState, useEffect, createContext, useContext } from "react";
import { 
  Typography, Container, Box, useMediaQuery, useTheme 
} from "@mui/material";
import { useParams } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../firebase';
import { ThemeProvider, createTheme } from "@mui/material/styles";
import ResponsiveJoinedAppBar from "../components/AppBarLoggedIn";

// Create Theme Context
const ThemeContext = createContext();

const ResponsiveLayout = () => {
    
    useContext(ThemeContext);
    const theme = useTheme();
    const isMedium = useMediaQuery(theme.breakpoints.down("lg"));
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    const { eventCode } = useParams();  // Capture the eventCode from the URL
    const [eventDetails, setEventDetails] = useState(null);
    const [eventDocId, setEventDocId] = useState(null);
    const [error, setError] = useState('');


    useEffect(() => {
        if (eventCode) {
          fetchEvent(eventCode);
        }
      }, [eventCode]);
      
    
      const fetchEvent = async (code) => {
        try {
          setError('');
          setEventDetails(null);
          setEventDocId(null);
    
          // Find the event document by eventCode
          const eventsRef = collection(db, 'events');
          const eventQuery = query(eventsRef, where('eventCode', '==', code));
          const eventSnapshot = await getDocs(eventQuery);
    
          if (!eventSnapshot.empty) {
            // Assume the first matching event document
            const eventDoc = eventSnapshot.docs[0];
            const eventData = eventDoc.data();

            // Setting the page title 
            {document.title = "nKuvu - " + eventData.eventName}
    
            setEventDocId(eventDoc.id);  // Store document ID for post retrieval
            setEventDetails({
              eventImage: eventData.eventImageURL,
              eventName: eventData.eventName,
              eventCode: eventData.eventCode,
              eventOwnerName: eventData.eventOwnerName,
            });
          } else {
            setError('No event found with that event code.');
          }
        } catch (err) {
          console.error("Error fetching event:", err);
          setError('Failed to retrieve event data.');
        }
      };
    
    
  return (
    
    <Box 
     sx={{ display: "flex", flexDirection: "column", 
     minHeight: "100vh",  
     bgcolor: "white", 
     }}>
      
      {/* Sticky Top Bar */}
      {/* <AppBar position="sticky" color="default">
        <Toolbar>
          <Typography variant="h6" sx={{ flexGrow: 1 }}>
            NKUVU
          </Typography>
          <IconButton onClick={toggleDarkMode} color="inherit">
            {darkMode ? <Brightness7Icon /> : <Brightness4Icon />}
          </IconButton>
        </Toolbar>
      </AppBar> */}

      <ResponsiveJoinedAppBar/>

      {/* Main Content */}
      <Container component="main" sx={{ flex: 1, display: "flex", 
        justifyContent: "center"
         }}>
        <Box
          sx={{
            display: "block",
            gridTemplateColumns: isMobile
              ? "1fr"
              : isMedium
              ? "100%"
              : "100%",
            gap: "20px",
            maxWidth: "1200px",
            width: "100%", 
            display:"flex",
            minHeight: "400px",
            borderRadius:3,
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: 2,               
          }}
        >
         
          {/* Main Content */}
          <Box sx={{ 
            // bgcolor: "grey.100", 
            p: 2, 
             }}>
            <Typography variant="h1" textAlign="center">404</Typography>
            <Typography variant="h3" textAlign="center">PAGE NOT FOUND</Typography>
            
          </Box>

          
        </Box>
      </Container>

      {/* Footer */}
      <Box component="footer" sx={{ bgcolor: 'background.paper', textAlign: "center", py: 2, mt: "auto" }}>
        <Typography variant="body2" color="text.primary">© 2025 nKuvu</Typography>
      </Box>
    </Box>
  );
};

// Theme Provider Wrapper
const App = () => {
  const [darkMode, setDarkMode] = useState(false);

  const theme = createTheme({
    palette: {
      mode: darkMode ? "dark" : "light",
    },
  });

  const toggleDarkMode = () => setDarkMode(!darkMode);

  return (
    <ThemeContext.Provider value={{ darkMode, toggleDarkMode }}>
      <ThemeProvider theme={theme}>
        <ResponsiveLayout />
      </ThemeProvider>
    </ThemeContext.Provider>
  );
};

export default App;
